import { ModalDialog } from '@fukuri-admins/ui/common';
import {
  FileUploadFieldController,
  RadioFieldController,
  ScheduledDateTimeFieldController,
} from '@fukuri-admins/ui/common/Form';
import { DownloadIcon } from '@fukuri-admins/ui/common/Icons';
import { buttonVariants } from '@fukuri-admins/ui/shared/buttonVariants';
import styles from './styles.module.scss';

type Props = {
  /** 削除方法の現在値 */
  registrationType: 'immediate' | 'scheduled';
  /** 削除ボタンの disabled 状態 */
  isConfirmDisabled: boolean;
  /** モーダルを閉じるコールバック */
  onClose: () => void;
  /** 削除ボタン押下時のコールバック */
  onConfirm: () => void;
};

const REGISTRATION_TYPE_OPTIONS = [
  { value: 'immediate', label: '今すぐ削除する' },
  { value: 'scheduled', label: '削除予約をする' },
];

export const UserBulkDeletionPresentation: React.FC<Props> = ({
  registrationType,
  isConfirmDisabled,
  onClose,
  onConfirm,
}) => (
  <ModalDialog
    isOpen
    title='利用者の一括削除'
    description=''
    onClose={onClose}
    onConfirm={onConfirm}
    confirmText='削除'
    variant='lg'
    isConfirmDisabled={isConfirmDisabled}
  >
    <div className={styles.content}>
      {/* 削除方法セクション */}
      <div className={styles.howToUseSection}>
        <div className={styles.howToUseTitleRow}>
          <span className={styles.howToUseTitle}>削除方法</span>
        </div>
        <ol className={styles.howToUseList}>
          <li>以下のテンプレート（CSVファイル）をダウンロード</li>
          <li>CSVファイルの2行目から削除対象の従業員情報を入力</li>
          <li>CSVファイルをアップロード</li>
        </ol>
        <div className={styles.templateButtons}>
          <a
            href='/templates/deletion/user_template_utf.csv'
            download='user_template_utf.csv'
            className={buttonVariants({ variant: 'secondary', size: 'xs' })}
          >
            <DownloadIcon size='xs' />
            テンプレート（UTF-8）
          </a>
          <span className={styles.templateSeparator}>または</span>
          <a
            href='/templates/deletion/user_template_sjis.csv'
            download='user_template_sjis.csv'
            className={buttonVariants({ variant: 'secondary', size: 'xs' })}
          >
            <DownloadIcon size='xs' />
            テンプレート（Shift-JIS）
          </a>
        </div>
      </div>

      {/* CSVファイルアップロード */}
      <FileUploadFieldController
        name='file'
        fieldWrapperProps={{
          labelText: 'CSVファイル',
          beforeMessage:
            '空白行の処理に時間がかかる場合があるため、空白行を削除してからアップロードしてください。',
        }}
        fileUpload={{
          type: 'file',
          accept: ['csv'],
          maxSizeMb: 10,
        }}
      />

      {/* 削除日時の設定 */}
      <div className={styles.registrationTypeSection}>
        <RadioFieldController
          name='registrationType'
          fieldWrapperProps={{
            labelText: '削除日時の設定',
          }}
          radioGroup={{
            options: REGISTRATION_TYPE_OPTIONS,
            direction: 'column',
            gap: 8,
          }}
        />
        {registrationType === 'scheduled' && (
          <div className={styles.scheduledDateTimeWrapper}>
            <ScheduledDateTimeFieldController />
          </div>
        )}
      </div>
    </div>
  </ModalDialog>
);
